<template>
	<div class="component article-share">
		<span class="uk-navbar-item uk-padding-small">
			<span v-show="label">{{ label }}</span>
			<span class="icon material-symbols-outlined"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M720-80q-50 0-85-35t-35-85q0-7 1-14.5t3-13.5L322-392q-17 15-38 23.5t-44 8.5q-50 0-85-35t-35-85q0-50 35-85t85-35q23 0 44 8.5t38 23.5l282-164q-2-6-3-13.5t-1-14.5q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-23 0-44-8.5T638-672L356-508q2 6 3 13.5t1 14.5q0 7-1 14.5t-3 13.5l282 164q17-15 38-23.5t44-8.5q50 0 85 35t35 85q0 50-35 85t-85 35Zm0-640q17 0 28.5-11.5T760-760q0-17-11.5-28.5T720-800q-17 0-28.5 11.5T680-760q0 17 11.5 28.5T720-720ZM240-440q17 0 28.5-11.5T280-480q0-17-11.5-28.5T240-520q-17 0-28.5 11.5T200-480q0 17 11.5 28.5T240-440Zm480 280q17 0 28.5-11.5T760-200q0-17-11.5-28.5T720-240q-17 0-28.5 11.5T680-200q0 17 11.5 28.5T720-160Zm0-600ZM240-480Zm480 280Z"/></svg></span>
		</span>
		<div uk-dropdown="mode: click">
			<ul class="uk-nav uk-dropdown-nav">
				<li><a href="javascript:void(0)" @click="shareOnWhatsApp"><span uk-icon="icon: whatsapp" class="uk-margin-small-right"></span> WhatsApp</a></li>
				<li><a href="javascript:void(0)" @click="shareOnFacebook"><span uk-icon="icon: facebook" class="uk-margin-small-right"></span> Facebook</a></li>
				<li><a href="javascript:void(0)" @click="shareOnTwitter"><span uk-icon="icon: twitter" class="uk-margin-small-right"></span>X</a></li>
				<li><a href="javascript:void(0)" @click="shareOnLinkedIn"><span uk-icon="icon: linkedin" class="uk-margin-small-right"></span>LinkedIn</a></li>
				<li><a :href="emailLink"><span uk-icon="icon: mail" class="uk-margin-small-right"></span> Email</a></li>
				<li><a href="javascript:void(0)" @click="copyToClipboard"><span uk-icon="icon: link" class="uk-margin-small-right"></span> Link kopiëren</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		siteName: {
			type: String,
			default: '',
			required: true
		},
		url: {
			type: String,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		mailto: {
			type: String,
			required: true,
			default: 'info@site.com'
		},
		label: {
			type: String,
			required: false
		}
	},
	mounted() {
	},
	computed: {
		emailLink() {
			const subject = encodeURIComponent(`Bekijk dit artikel op ${this.siteName}`);
			const body = encodeURIComponent(`${this.title}:\n${this.url}`);
			return `mailto:${this.mailto}?subject=${subject}&body=${body}`;
		}
	},
	methods: {
		shareOnWhatsApp() {
			var component = this;
			const url = encodeURIComponent(this.url);
			const title = encodeURIComponent(this.title);				
			if (component.$root.device.desktop){
					window.open(`https://api.whatsapp.com:/send?text=Bekijk ${title}: ${url}`);
			} else if(component.$root.device.mobile) {
					window.open(`whatsapp://send?text=Bekijk ${title}: ${url}`);
			}
		},
		shareOnFacebook() {
			const url = encodeURIComponent(this.url);
			window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
		},
		shareOnTwitter() {
			const url = encodeURIComponent(this.url);
			const title = encodeURIComponent(this.title);
			window.open(`https://twitter.com/intent/tweet?url=${url}&text=${title}`, '_blank');
		},
		shareOnLinkedIn() {
			const url = encodeURIComponent(this.url);
			const title = encodeURIComponent(this.title);
			window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`, '_blank');
		},
		copyToClipboard() {
			const urlInput = document.createElement('input');
			urlInput.value = this.url;
			document.body.appendChild(urlInput);
			urlInput.select();
			document.execCommand('copy');
			document.body.removeChild(urlInput);

			UIkit.notification({
				message: 'URL naar je clipboard gekopiëerd',
				status: 'success',
				pos: 'bottom-center'
			});

		}
	}
}
</script>

<style scoped>	
	
.component.article-share {
}
.component.article-share:hover .icon {
	color: var(--tint-color);
}
.component.article-share:hover svg {
	fill: var(--tint-color);
}
</style>
